import React from "react";
import { Box, Chip, CircularProgress, Paper, Typography } from "@mui/material";

const FeesSection = ({
  formData,
  feesList,
  isFeesLoading,
  handleFeeSelection,
  handleSelectAllFees,
  handleDeselectAllFees,
  isFeeSelected,
  formatFeeName,
  getFeeById,
  errors = {},
}) => {
  return (
    <div className="mb-8">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">Plan Fees</h3>
        <div className="space-x-2">
          <button
            type="button"
            onClick={handleSelectAllFees}
            className="px-3 py-1 text-sm bg-blue-100 text-blue-700 rounded hover:bg-blue-200"
            disabled={isFeesLoading || feesList.length === 0}
          >
            Select All
          </button>
          <button
            type="button"
            onClick={handleDeselectAllFees}
            className="px-3 py-1 text-sm bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
          >
            Deselect All
          </button>
        </div>
      </div>

      {isFeesLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
          <CircularProgress />
        </Box>
      ) : feesList.length > 0 ? (
        <div
          className={`grid grid-cols-1 gap-3 p-4 border rounded-lg max-h-96 overflow-y-auto ${
            errors.fees ? "border-red-400" : ""
          }`}
        >
          {feesList.map((fee) => {
            const feeId = (fee._id || fee.id)?.toString();

            return (
              <div
                key={feeId}
                className="flex items-start space-x-3 p-3 hover:bg-gray-50 rounded border border-gray-100"
              >
                <input
                  type="checkbox"
                  id={`fee-${feeId}`}
                  checked={isFeeSelected(feeId)}
                  onChange={() => handleFeeSelection(feeId)}
                  className="mt-1 rounded text-blue-600 focus:ring-blue-500"
                />
                <div className="flex-1">
                  <label
                    htmlFor={`fee-${feeId}`}
                    className="text-sm font-medium text-gray-700 cursor-pointer"
                  >
                    {formatFeeName(fee)}
                  </label>
                  <div className="flex flex-wrap gap-2 mt-2">
                    {fee.minimumFlightIssued !== undefined && (
                      <Chip
                        label={`Min Flights: ${fee.minimumFlightIssued}`}
                        size="small"
                        sx={{
                          bgcolor: "#EFF6FF",
                          color: "#1F4FFF",
                          height: 20,
                          fontSize: "0.7rem",
                        }}
                      />
                    )}
                    {fee.maximumFlightIssued !== undefined && (
                      <Chip
                        label={`Max Flights: ${fee.maximumFlightIssued}`}
                        size="small"
                        sx={{
                          bgcolor: "#EFF6FF",
                          color: "#1F4FFF",
                          height: 20,
                          fontSize: "0.7rem",
                        }}
                      />
                    )}
                    {fee.isDefault && (
                      <Chip
                        label="Default"
                        size="small"
                        sx={{
                          bgcolor: "#FEF3C7",
                          color: "#D97706",
                          height: 20,
                          fontSize: "0.7rem",
                        }}
                      />
                    )}
                  </div>
                  {fee.description &&
                    fee.description !== "Default Fee" && (
                      <Typography
                        variant="caption"
                        className="text-gray-500 block mt-2"
                      >
                        {fee.description}
                      </Typography>
                    )}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <Paper sx={{ p: 4, textAlign: "center", bgcolor: "#F9FAFB" }}>
          <Typography variant="body2" className="text-gray-500">
            No fees available. Please create fees first.
          </Typography>
        </Paper>
      )}

      {errors.fees ? (
        <p className="mt-2 text-sm text-red-600">{errors.fees}</p>
      ) : null}

      {formData.fees && formData.fees.length > 0 && (
        <Typography
          variant="caption"
          className="text-gray-500 block mt-2"
        >
          {formData.fees.length} fee(s) selected
        </Typography>
      )}
    </div>
  );
};

export default FeesSection;
